import { render, staticRenderFns } from "./ComfirmationTable.vue?vue&type=template&id=c1837d8c&scoped=true&"
import script from "./ComfirmationTable.vue?vue&type=script&lang=js&"
export * from "./ComfirmationTable.vue?vue&type=script&lang=js&"
import style0 from "./ComfirmationTable.vue?vue&type=style&index=0&id=c1837d8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1837d8c",
  null
  
)

export default component.exports